import { Typography } from '@mui/material';
import { bagStatuses } from '@/constants/Bag';
import ArrowRightIcon from '@/assets/icons/arrow-right-small-icon.svg?react';
import { RelationLink } from '@/components/global/buttons/ListButtons.jsx';

export const TransactionCountField = record => {
    if (!record) return null;

    const transactionCount = record.transactionCount || 0;

    return (
        <Typography variant='body2' className={record.status === bagStatuses.in_progress ? 'gray' : ''}>
            <RelationLink
                label={transactionCount}
                resource='transaction'
                filter='bagId_in'
                startIcon={null}
                endIcon={<ArrowRightIcon />}
                sx={{ fontWeight: 600 }}
            />
        </Typography>
    );
};
